/**
 * Cognito User via AWS API
 * Bug Tickets in Github
 * https://github.com/aws/amazon-cognito-identity-js/pull/108
 */

import { CognitoUserPool as _CognitoUserPool, AuthenticationDetails, CognitoUser, CookieStorage } from "amazon-cognito-identity-js"
import UserUtils from '@/utils/UserUtils'
import { Promise } from "es6-promise"
import user from '@/api/user'
import store from '@/store'
import Vue from 'vue'

var AWS = require('aws-sdk');

export let cognitoUser = null
export let domainName = process.env.COOKIES_DOMAIN

export let userPool = new _CognitoUserPool({
  UserPoolId: process.env.COGNITO_USER_POOL_ID,
  ClientId: process.env.COGNITO_CLIENT_ID,
  Storage: new CookieStorage({domain: domainName, expires: 1, secure: false})
})

export let getNestedObject =  function(nestedObj, pathArr){
  return pathArr.reduce((obj, key) => (obj && obj[key] !== 'undefined') ? obj[key] : undefined, nestedObj);
}     


export default {
  /**
   * Login
   */
  login (params) {
    return new Promise((resolve, reject) => {
      let authenticationData = {
        Username: params.email,
        Password: params.password
      }
      let authenticationDetails = new AuthenticationDetails(authenticationData)
      
      let userData = {
        Username: params.email,
        Pool: userPool,
        Storage: new CookieStorage({domain: domainName, expires: 1, secure: false})
      }
      let cognitoUser = new CognitoUser(userData)
      
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: function (result) {
          AWS.config.region = "ap-northeast-1";
    
          AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: process.env.COGNITO_IDENTITY_POOL_ID,
            Logins: {
             [process.env.USER_POOL_PROVIDER]: result.getIdToken().getJwtToken()
            }
          });
          AWS.config.credentials.refresh(function(error) {
            if (error) {
              console.error(error)
              reject(error)
            } else {
              var sessionData = {
                provider: process.env.USER_POOL_PROVIDER,
                accessToken: result.getIdToken().getJwtToken(),
                cognitoIdentiyId: AWS.config.credentials.identityId,
                sns_registration: false,
                user_id: parseInt(cognitoUser.username)
              }
              console.log( AWS.config.credentials)
              let response = {
                result: result,
                session: sessionData
              }
              resolve(response)
            }
          })
        },
        onFailure: function (error) {
          reject(error)
        }
      })
    })
  },

  /**
   * Set User Attributes
   */
  setUserAttributes () {
    return new Promise((resolve, reject) => {
      let attributes = {
        userId: '',
        email: '',
        languageId: 0,
        accessToken: '',
        provider: '',
        sns_registration: false
      }
    
      let cognitoUser = userPool.getCurrentUser()
      // When user is not logged in
      if (cognitoUser === null) {
        user.getUserMeta().then(result => {
          console.log(result);
          attributes.userId = getNestedObject(result.data, ['data', 0, 'user_id'])
          attributes.accessToken = result.config.headers.token
          attributes.provider = result.config.headers.provider
          attributes.email = getNestedObject(result.data, ['data', 0, 'email'])
          attributes.languageId = getNestedObject(result.data, ['data', 0, 'language_id'])
          attributes.languageName = UserUtils.convertToLanguageName(getNestedObject(result.data, ['data', 0, 'language_id']))
          attributes.sns_registration = true

          store.state.userMeta =  attributes
          store.state.userAttributes =  getNestedObject(result.data, ['data', 0])
          return resolve(attributes)
        }).catch((error) => {
          // if(error.response.status === 403){
            store.state.loginExecuteStatus =  'Session Expired!'
            return reject(attributes)
          // }
        })
      }else{
        cognitoUser.getSession(function (error, session) {
          if (error) {
            return reject(attributes)
          }
          // set access token
          attributes.userId = cognitoUser.username
          attributes.accessToken = session.getAccessToken().getJwtToken()
          attributes.provider = process.env.USER_POOL_PROVIDER
          
          user.getUserMeta().then(result => {
            console.log(result);
            attributes.userId = getNestedObject(result.data, ['data', 0, 'user_id'])
            attributes.accessToken = session.getAccessToken().getJwtToken()
            attributes.provider = result.config.headers.provider
            attributes.email = getNestedObject(result.data, ['data', 0, 'email'])
            attributes.languageId = getNestedObject(result.data, ['data', 0, 'language_id'])
            attributes.languageName = UserUtils.convertToLanguageName(getNestedObject(result.data, ['data', 0, 'language_id']))
  
            store.state.userMeta =  attributes
            store.state.userAttributes =  getNestedObject(result.data, ['data', 0])
            return resolve(attributes)
          }).catch((error) => {
            // if(error.response.status === 403){
              store.state.loginExecuteStatus =  'Session Expired!'
              return reject(attributes)
            // }
          })
          // cognitoUser.getUserAttributes(function (error, results) {
          //   if (error) {
          //     return reject(attributes)
          //   }

          //   attributes.userId = cognitoUser.username
          //   attributes.accessToken = session.getAccessToken().getJwtToken()
          //   attributes.email = getNestedObject(session, ['idToken', 'payload', 'email'])
          //   attributes.languageId = getNestedObject(session, ['idToken', 'payload', 'custom:lang_id'])
          //   attributes.languageName = UserUtils.convertToLanguageName(getNestedObject(session, ['idToken', 'payload', 'custom:lang_id']))
            
          //   store.state.userMeta =  attributes

          //   return resolve(attributes)
          // })
        })
      }
    })
  },

  /**
   * Logout
   */
  logout () {
    return new Promise((resolve, reject) => {

      let cognitoUser = userPool.getCurrentUser()

      if (cognitoUser !== null) {
        cognitoUser.signOut()
        cognitoUser = null
        return resolve('cognito Logout')
      } else {
        let provider = store.state.userMeta.provider
  
        if(provider === 'accounts.google.com'){
          Vue.googleAuth().signOut((success) => { 
            return resolve('Google Logout')
          }, (error) => {
            return reject('Something went weong with google logout!')
          })
        }else{
          FB.getLoginStatus(function(response) {
            if (response.status === 'connected'){
              FB.logout().then(() => {
                return resolve('Facebook Logout')
              }).catch(()=>{
                return reject('Something went wrong with Facebook Logout!');
              })
            }
          });
        }
      }
    })
    // return Promise.resolve()
  },

  /**
   * Check login
   */
  isLogin () {
    let cognitoUser = userPool.getCurrentUser()
    // console.log('Login Check....');
    // console.log(cognitoUser);
    if(cognitoUser === null){
      cognitoUser = (store.getters.userId !== '') ? true: null
    }
    return cognitoUser !== null
  },

  /**
   * 
   * @param {*} response 
   */
  snsRegistrationGoogle(authResult){
    return new Promise((resolve, reject) => {
      if (authResult['id_token']) {

        AWS.config.region = 'ap-northeast-1'; // Region  
        if (AWS.config.credentials && AWS.config.credentials.clearCachedId) {
          AWS.config.credentials.clearCachedId();
        }
    
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: process.env.COGNITO_IDENTITY_POOL_ID,
          Logins: {
            'accounts.google.com': authResult['id_token']
          }
        });
  
        // obtain credentials
        AWS.config.credentials.get(function(err) {
          if (!err) {
            // console.log('Cognito Identity Id: ' + AWS.config.credentials.identityId);
            const identityId = AWS.config.credentials.identityId;
  
            var sessionData = {
              provider: 'accounts.google.com',
              accessToken: authResult['id_token'],
              cognitoIdentiyId: identityId,
              sns_registration: true,
            }
            user.checkUserExistence(identityId).then((result) => {
              if(result){
                return resolve(sessionData)
              }else{
                return reject(null)
              }
            }).catch((err) => { return reject(null) })
          } else { console.log('ERROR: ' + err); }
        })
      } else {
        console.log('User not logged in!');
      }      
    })
  },



  /**
   * FB User Login Method 
   * @param {*} response 
   */
  snsRegistrationFB(response){
    return new Promise((resolve, reject) => {
      if (response.status === 'connected') {
        // Logged into your app and Facebook.
        AWS.config.region = 'ap-northeast-1'; // Region
        var Credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: process.env.COGNITO_IDENTITY_POOL_ID,
          Logins: {
            'graph.facebook.com': response.authResponse.accessToken
          }
        });

        Credentials.refresh(function(res, err){
          var identityId = Credentials.identityId;
          var sessionData = {
            provider: 'graph.facebook.com',
            accessToken: response.authResponse.accessToken,
            cognitoIdentiyId: identityId,
            sns_registration: true,
          }
  
          user.checkUserExistence(identityId).then((result) => {
            if(result){
              return resolve(sessionData)
            }else{
              return reject(null)
            }
          }).catch((err) => { return reject(null) })

        });
      } else if (response.status === 'not_authorized') {
        console.log('Please log into this app');
      } else {
        console.log('Please log into Facebook.');
      }
    })
  }

} // End of Default Export Module




// WEBPACK FOOTER //
// ./src/api/cognito-user.js